import { DocumentReference } from '@angular/fire/firestore';
import { Model } from './abstract-model';
import { CategoryGroup, ICategoryGroup } from './category-group';
import SubCategory from './sub-category';

class Category extends Model {
  name: string;
  products_count = 0;
  sortIndex = 0;
  img: string;
  key?: string;
  enabled: boolean;
  businesses?: {
    [business: string]: boolean;
  };
  subCategories: SubCategory[] = [];

  categoryGroupRef: DocumentReference | undefined;

  /**
   * Obtiene la instancia (promise) del grupo de la categorÃ­a actual, si la posee.
   *
   * @since 0.2.0
   * @author Nelson Martell <nelson6e65[at]gmail.com>
   */
  async categoryGroup(): Promise<CategoryGroup | undefined> {
    if (this.categoryGroupRef) {
      const snapshot = await this.categoryGroupRef.get();

      if (snapshot.exists) {
        return new CategoryGroup(snapshot.data() as ICategoryGroup, snapshot.id);
      }
    }

    return undefined;
  }
}

export default Category;
